export default __webpack_public_path__ + "static/media/preview.c401a8b9.svg";